<template>
  <div class="app-wrapper">
      <layout-header />
      <app-main />
  </div>
</template>

<script>
import AppMain from './components/AppMain.vue'
import LayoutHeader from "./components/LayoutHeader.vue";
export default {
  name: 'Layout',
  components: {
    AppMain,
    LayoutHeader
  }
}
</script>